import * as React from "react";

import { useCurrentChatContext } from "@agent-ui/features/chat/providers/CurrentChatContext";
import { Button } from "@replo/design-system/components/button/Button";
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuTrigger,
} from "@replo/design-system/components/menu/Menu";
import { ImagePlus, Lightbulb, Plus } from "lucide-react";

export const MessageInputActionsMenu: React.FC<{
  handleAttachFiles: () => void;
}> = ({ handleAttachFiles }) => {
  const { dispatchCurrentChat } = useCurrentChatContext();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleInspirationAndClose = () => {
    dispatchCurrentChat({ type: "openInspirationMenu" });
  };

  return (
    <Menu open={isOpen} onOpenChange={setIsOpen}>
      <MenuTrigger
        onClick={(e) => {
          e.stopPropagation();
        }}
        render={<Button icon variant="secondary" size="base" />}
      >
        <Plus />
      </MenuTrigger>
      <MenuContent side="top" align="start" UNSAFE_className="ml-1">
        <MenuItem
          startEnhancer={<ImagePlus size={16} />}
          onClick={handleAttachFiles}
          label="Attach Files"
        />
        <MenuItem
          startEnhancer={<Lightbulb size={16} />}
          onClick={handleInspirationAndClose}
          label="Inspiration"
        />
      </MenuContent>
    </Menu>
  );
};
